import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { Heart, Sun, Compass, Footprints } from 'lucide-react';
const pillars = [{
  icon: Heart,
  name: 'Autoestima',
  rebuilds: 'Tu percepción de tu propio valor — la base de todo'
}, {
  icon: Sun,
  name: 'Esperanza',
  rebuilds: 'Tu capacidad de creer que un futuro diferente es posible'
}, {
  icon: Compass,
  name: 'Propósito',
  rebuilds: "El 'para qué' que te hace levantarte cuando todo duele"
}, {
  icon: Footprints,
  name: 'Acción',
  rebuilds: 'Los sistemas diarios que convierten la intención en realidad'
}];
export function MechanismSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section ref={ref} className="w-full bg-[var(--midnight)] py-24 md:py-32" data-id="element-230">
      <motion.div initial={{
      opacity: 0,
      y: 40
    }} animate={isInView ? {
      opacity: 1,
      y: 0
    } : {}} transition={{
      duration: 0.8
    }} className="max-w-6xl mx-auto px-6" data-id="element-231">
        <div className="space-y-16" data-id="element-232">
          <div className="text-center space-y-6" data-id="element-233">
            <h2 className="font-display text-4xl md:text-5xl text-[var(--warm-gold)]" data-id="element-234">
              El Mecanismo Que Lo Cambia Todo
            </h2>
            <h3 className="font-display text-3xl md:text-4xl italic text-[var(--cream)]" data-id="element-235">
              El Proceso del Renacer
            </h3>
          </div>

          <p className="text-xl text-[var(--cream)]/90 leading-relaxed max-w-4xl mx-auto text-center" data-id="element-236">
            Existe una razón por la que algunas personas logran transformarse
            completamente después de tocar fondo — y otras vuelven a caer una y
            otra vez. No es fuerza de voluntad. No es suerte. No es que Dios las
            quiera más.
          </p>

          <p className="text-2xl font-semibold text-[var(--sunset-coral)] text-center" data-id="element-237">
            Es que encontraron el proceso correcto.
          </p>

          {/* 4 Pillars */}
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 pt-8" data-id="element-238">
            {pillars.map((pillar, index) => {
            const Icon = pillar.icon;
            return <motion.div key={index} initial={{
              opacity: 0,
              y: 30
            }} animate={isInView ? {
              opacity: 1,
              y: 0
            } : {}} transition={{
              duration: 0.6,
              delay: index * 0.15
            }} className="bg-[var(--dusk-purple)]/30 backdrop-blur-sm p-8 rounded-2xl border border-[var(--warm-gold)]/20 space-y-4" data-id="element-239">
                  <div className="w-14 h-14 bg-[var(--warm-gold)] rounded-full flex items-center justify-center" data-id="element-240">
                    <Icon className="w-7 h-7 text-[var(--midnight)]" data-id="element-241" />
                  </div>
                  <h4 className="font-display text-2xl text-[var(--warm-gold)]" data-id="element-242">
                    {pillar.name}
                  </h4>
                  <p className="text-[var(--cream)]/80 leading-relaxed" data-id="element-243">
                    {pillar.rebuilds}
                  </p>
                </motion.div>;
          })}
          </div>

          {/* Faith element */}
          <div className="pt-12" data-id="element-244">
            <p className="font-display text-2xl md:text-3xl italic text-[var(--cream)]/90 text-center leading-relaxed max-w-4xl mx-auto" data-id="element-245">
              Y sobre estos cuatro pilares, algo que la mayoría de los libros de
              autoayuda ignoran completamente: La fe. La presencia de un Dios
              que no te abandonó en tu dolor — aunque sintieras que sí.
            </p>
          </div>
        </div>
      </motion.div>
    </section>;
}